<ul class="UNFAPP-lvcls-curses-list">
  <li>
      <div class="UNFAPP-lvcls-curses-box">
          <div class="top-lvcls-info-area">
              <div class="lvcls-mobhdng">{{courseData?.title}}</div>
              <div class="lvcls-info-imgframe UNFAPP-corse-imgfrme">
                  <img class="lvcls-info-imgframe-img UNFAPP-corse-imgfrme-img" src="{{courseData?.batchPicture?.length ? courseData?.batchPicture[0] : courseData?.batchPicture}}" (error)="_helper.profileImgError($event)" />
                  <span class="lvcls-sta-tag d-hide" [ngClass]="{'orange': isUpcomming || isStartTomrrow || (waitingDays > 0), 'blue': params?.type == 'past', 'green': params?.type == 'ongoing'}">{{params?.type == 'ongoing' ? 'ONGOING' : params?.type == 'past' ? 'COMPLETED' : 'UPCOMING' }}</span>
              </div>
              <div class="lvcls-info-rgtpart">
                  <div class="lvcls-info-innr">
                      <div class="lvcls-info-hdrpart">
                          <h3 class="lvcls-hdng lvcls-dskhdng">{{courseData?.title}}</h3>
                          <div class="lvcls-curs-tag" *ngIf="courseData.courseType === 'fullYearCourse'">Full course</div>
                          <div class="lvcls-curs-tag" *ngIf="courseData.courseType === 'crashCourse'">Crash course</div>
                          <div class="lvcls-curs-tag" *ngIf="courseData.courseType === 'microCourse'">Micro course</div>
                          <div class="lvcls-curs-tag" *ngIf="courseData.courseType === 'freeCourse'">Free course</div>
                      </div>
                      <div class="UNFAPP-lvcls-grdcol">
                          <ul class="UNFAPP-lvcls-grdtm-lst-area">
                              <li>
                                  <img src="assets/img/grade-cap.svg" class="grdtm-lst-img" />
                                  <span>Grade {{courseData?.grade}}</span>
                              </li>
                              <li>
                                  <img src="assets/img/clock-icon.svg" class="grdtm-lst-img" />
                                  <span>{{courseData?.duration}} Hours</span>
                              </li>
                              <li>
                                  <span class="grd-cls-nm">{{courseData?.language}}</span>
                              </li>
                          </ul>
                      </div>
                      <div class="lvcls-curses-durnt-rw m-hide"  *ngIf="dataType == 'myCourse'">
                          <div class="lvcls-curses-durnt-text">{{courseData?.schedule?.startDate | date: 'd MMM, YYYY'}} to {{courseData?.schedule?.endDate | date: 'd MMM, YYYY'}}</div>
                          <span class="lvcls-sta-tag" [ngClass]="{'orange': isUpcomming || isStartTomrrow || (waitingDays > 0), 'blue': params?.type == 'past', 'green': params?.type == 'ongoing'}">{{params?.type == 'ongoing' ? 'ONGOING' : params?.type == 'past' ? 'COMPLETED' : 'UPCOMING' }}</span>
                      </div>
                  </div>
              </div>
          </div>
          <div class="btm-lvcls-info">
              <div class="btm-lvcls-innr">
                  <ul class="UNFAPP-lvcls-sbjct-lst">
                    <ng-container *ngFor="let sub of courseData?.subjects">
                        <li *ngIf="sub && showScience && sub!='Physics' && sub!='Chemistry' && sub!='Biology'">
                            <img src="assets/img/subject-icons/{{sub?.toLowerCase()}}-icon.svg"
                                class="sbjct-lst-img" *ngIf="sub != ''"/><span>{{sub}}</span>
                        </li>
                        <li *ngIf="sub && !showScience">
                            <img src="assets/img/subject-icons/{{sub?.toLowerCase()}}-icon.svg"
                                class="sbjct-lst-img" *ngIf="sub != ''"/><span>{{sub}}</span>
                        </li>
                    </ng-container>
                    <li *ngIf="(showScience && !(checkIfNonScienceSubjectExists(courseData?.subjects)))">
                        <img src="assets/img/subject-icons/science-icon.svg"
                            class="sbjct-lst-img" /><span>Science</span>
                    </li>
                  </ul>
                  <div class="lvcls-curses-durnt-rw d-hide" *ngIf="dataType == 'myCourse'">
                      <div class="lvcls-curses-durnt-text mview d-hide">
                        {{courseData?.schedule?.startDate | date: 'd MMM, YYYY'}} to {{courseData?.schedule?.endDate | date: 'd MMM, YYYY'}}
                      </div>
                  </div>
                  <div class="UNFAPP-lvcls-actncol revert">
                    <div class="first-btn-col">
                    <button class="UNFAPP-lvcls-txtbtn UNFAPP-gapright" *ngIf="dataType == 'allCourse'" [routerLink]="['/course', courseData.id]">
                        <span class="lvcls-mobhide">COURSE </span>DETAILS 
                        <i class="fa fa-caret-right"></i>
                    </button>
                    </div>
                    <app-custom-button *ngIf="dataType == 'allCourse' "  type="button" [cta]="{name:'ENROLL NOW',type:'enroll', dataType: dataType, data:courseData}"></app-custom-button>
                    <app-custom-button *ngIf="dataType == 'myCourse'" type="button" [cta]="{name:'VIEW course',type:'viewCourse', dataType: dataType, data:courseData}"></app-custom-button>
                  </div>
              </div>
          </div>
      </div>
  </li>
</ul>